export type Language = "no" | "th" | "en";

export const translations: Record<Language, Record<string, string>> = {
  no: {
    // Nav
    "nav.home": "Hjem",
    "nav.services": "Tjenester",
    "nav.process": "Prosessen",
    "nav.faq": "FAQ",
    "nav.getQuote": "Få et tilbud",
    "nav.blog": "Blogg",
    "nav.menu": "Meny",

    // Hero
    "hero.badge": "✓ Godkjent oversettelse for UDI",
    "hero.headline": "Vi hjelper deg med alle dokumenter til UDI-søknaden.",
    "hero.sub": "Sertifisert oversettelse av thailandske dokumenter til norsk. Vi hjelper deg fra A til Å — fra dokumentliste til ferdig søknad.",
    "hero.cta": "Få gratis vurdering",
    "hero.whatsapp": "Chat på WhatsApp →",
    "hero.whatsappSubtle": "Eller chat med oss på WhatsApp →",
    "hero.trust1": "Svar innen 24 timer",
    "hero.trust2": "200+ dokumenter behandlet",
    "hero.trust3": "98% godkjent av UDI",
    "hero.availability": "🟢 Vi tar imot nye kunder nå",
    "hero.imgAlt": "Norske og thailandske pass med offisielle dokumenter",

    // Stats
    "stats.docsNum": "2000+",
    "stats.docs": "Dokumenter oversatt",
    "stats.approvedNum": "98%",
    "stats.approved": "Godkjent av UDI",
    "stats.experienceNum": "Over 40 års",
    "stats.experience": "Erfaring",
    "stats.responseNum": "24 timer",
    "stats.response": "Responstid",

    // Guarantee
    "guarantee.heading": "100% UDI-godkjent ",
    "guarantee.text": "Alle oversettelser er sertifisert og godkjent av norske myndigheter. Hvis dokumentet ikke godkjennes av UDI, reviderer vi det.",

    // Why choose us
    "why.heading": "Hvorfor velge NordicThai Translate?",
    "why.1.title": "Spesialisert ekspertise",
    "why.1.desc": "Vi jobber utelukkende med thai-norsk dokumentoversettelse.",
    "why.2.title": "Rask levering",
    "why.2.desc": "Standard 3–5 virkedager. Hastelevering 48 timer.",
    "why.3.title": "Personlig WhatsApp-service",
    "why.3.desc": "Direkte kontakt — ingen chatbots, ingen callsentre.",
    "why.4.title": "Komplett dokumenthjelp",
    "why.4.desc": "Vi sjekker hele søknaden, ikke bare oversetter.",

    // How it works
    "how.heading": "Slik fungerer det",
    "how.step1.title": "Kontakt oss",
    "how.step1.desc": "Send dokumentene dine via WhatsApp eller skjema — gratis og uforpliktende.",
    "how.step2.title": "Gratis vurdering",
    "how.step2.desc": "Vi sjekker hva du trenger og sender deg en komplett liste og pristilbud.",
    "how.step3.title": "Oversettelse",
    "how.step3.desc": "Sertifiserte oversettere oversetter dokumentene fra thai til norsk.",
    "how.step4.title": "Kvalitetskontroll",
    "how.step4.desc": "Hvert dokument sjekkes for nøyaktighet og sertifiseres.",
    "how.step5.title": "Levering",
    "how.step5.desc": "Motta dokumentene digitalt eller per post — klare for UDI.",

    // Services
    "services.heading": "Våre tjenester",
    "services.translation.title": "Sertifisert oversettelse",
    "services.translation.desc": "Alle offisielle dokumenter fra thai til norsk.",
    "services.review.title": "UDI dokumentgjennomgang",
    "services.review.desc": "Vi sjekker at du har alt UDI krever.",
    "services.package.title": "Komplett dokumentpakke",
    "services.package.desc": "Full pakke klar for innlevering.",
    "services.express.title": "Ekspresslevering 48t",
    "services.express.desc": "Hastebestilling tilgjengelig.",
    "services.price": "Fra 450 kr",
    "services.translation.price": "Fra 450 kr/dok",
    "services.review.price": "Fra 850 kr",
    "services.package.price": "Fra 2 900 kr",
    "services.express.price": "500 kr tillegg",
    "services.popular": "Mest populær",
    "services.whatsapp": "Chat på WhatsApp →",
    "services.quoteCta": "Få et gratis pristilbud →",

    // Document types
    "docs.heading": "Dokumenter vi oversetter",
    "docs.subtitle": "Alle dokumenter sertifiseres for norske myndigheter, UDI og politiet.",
    "docs.missing": "Mangler du dokumentet ditt på listen? Chat med oss →",
    "docs.0": "📄 Vigselsattest",
    "docs.1": "🏥 Fødselsattest",
    "docs.2": "🎓 Vitnemål",
    "docs.3": "🏠 Bostedsbevis",
    "docs.4": "💼 Arbeidskontrakt",
    "docs.5": "👮 Vandelsattest",
    "docs.6": "🛂 Passopplysninger",
    "docs.7": "📋 Kontoopplysninger",
    "docs.8": "💑 Familieregistrering",
    "docs.9": "🏦 Bankutskrift",
    "docs.10": "📞 Samboererklæring",
    "docs.11": "🩺 Legeerklæring",

    // Testimonials
    "testimonials.heading": "Hva kundene sier",
    "testimonials.1.quote": "Jeg visste ikke hva jeg trengte for UDI. De sendte meg en komplett liste og ordnet alt på én uke.",
    "testimonials.2.quote": "Vi giftet oss i Thailand og trengte oversettelse av vigselsattest. Raskt, profesjonelt og til riktig pris.",
    "testimonials.3.quote": "Anbefaler varmt! Søknaden ble godkjent første gang takket være at de hjalp meg med alle papirene.",
    "testimonials.verified": "Bekreftet kunde",

    // FAQ
    "faq.heading": "Ofte stilte spørsmål",
    "faq.1.q": "Hvilke dokumenter trenger jeg for UDI familieinnvandring?",
    "faq.1.a": "Vanlige dokumenter inkluderer: fødselsattest, vigselsattest, passkopier, politiattest, kontoutskrifter og dokumentasjon på bolig.",
    "faq.2.q": "Utfører dere notarisering?",
    "faq.2.a": "Vi notariserer ikke dokumenter selv, men vi forbereder og oversetter dokumentene dine slik at de oppfyller alle krav for notarisering og UDI-innlevering.",
    "faq.3.q": "Hvor lang tid tar oversettelsen?",
    "faq.3.a": "Standard oversettelse tar 3–5 virkedager. Ekspresslevering på 48 timer er tilgjengelig for hastetilfeller.",
    "faq.4.q": "Hva koster det?",
    "faq.4.a": "Prisen avhenger av antall og kompleksitet på dokumentene. Chat med oss på WhatsApp for et gratis prisoverslag.",
    "faq.5.q": "Hjelper dere thailendere som allerede bor i Norge?",
    "faq.5.a": "Ja. Vi hjelper både thailandske statsborgere bosatt i Norge og de som er i ferd med å flytte fra Thailand.",
    "faq.6.q": "Hvilke dokumenter trenger jeg for familiegjenforening?",
    "faq.6.a": "For familiegjenforening trenger du vanligvis gyldig pass, fødselsattest, vigselsattest (for ektefeller), politiattest og inntektsdokumentasjon fra referansepersonen i Norge.",
    "faq.7.q": "Trenger dokumentene mine legalisering eller apostille?",
    "faq.7.a": "Ekteskapsdokumenter til UDI trenger IKKE apostille eller legalisering. Derimot MÅ politiattester legaliseres av thailandsk utenriksdepartement før de sendes til Norge.",
    "faq.8.q": "Hvor er dere lokalisert?",
    "faq.8.a": "Vi holder til i Oslo sentrum, 1 minutt fra Thailands ambassade ved Hausmanns gate 7.",

    // About
    "about.heading": "Vi kjenner begge sider av søknaden",
    "about.body": "NordicThai Translate ble startet av en thai-norsk familie som selv gikk gjennom UDI-prosessen. Vi vet hvor stressende det er å navigere norsk byråkrati — og vi er her for å gjøre det enkelt for deg.",
    "about.bullet1": "Thai morsmål — vi forstår kulturen og konteksten",
    "about.bullet2": "Sertifisert for norske myndigheter — UDI og politiet",
    "about.bullet3": "Betjener hele Norge — fra Oslo til Tromsø",
    "about.cta": "Se hele prosessen →",

    // CTA
    "cta.text": "Klar til å starte? Chat med oss på WhatsApp — gratis og uforpliktende.",
    "cta.heading": "Klar til å sikre din UDI-søknad?",
    "cta.sub": "Vi hjelper deg med alt fra dokumentliste til godkjent søknad. Fyll ut skjemaet — vi svarer innen 24 timer.",
    "cta.micro1": "Gratis",
    "cta.micro2": "Raskt svar",
    "cta.micro3": "Ingen forpliktelse",
    "cta.button": "Få gratis vurdering →",
    "cta.stars": "⭐⭐⭐⭐⭐  Betrodd av 47+ familier i Norge",

    // Footer
    "footer.tagline": "Sertifisert oversettelse av thailandske dokumenter til norsk for UDI, ekteskap og familiegjenforening.",
    "footer.links": "Hurtiglenker",
    "footer.links.home": "Hjem",
    "footer.links.services": "Tjenester",
    "footer.links.documents": "Dokumenter",
    "footer.links.process": "Prosessen",
    "footer.links.blog": "Blogg",
    "footer.links.about": "Om oss",
    "footer.links.quote": "Få et tilbud",
    "footer.contact": "Kontakt",
    "footer.contactInquiry": "Send henvendelse",
    "footer.copyright": "© 2026 NordicThai Translate.",
    "footer.privacy": "Personvern",

    // Visit section
    "visit.heading": "Besøk oss",
    "visit.iframeTitle": "NordicThai Translate kontor",
    "visit.title": "Du må bestille time for å besøke oss",
    "visit.address": "Adresse",
    "visit.addressValue": "Hausmanns gate 7, 0186 Oslo",
    "visit.hours": "Åpningstider",
    "visit.hoursValue": "Man–Fre 09:00–17:00",
    "visit.cta": "Kontakt oss →",

    // Blog
    "blog.subtitle": "Veiledninger og tips om thai-norsk dokumentoversettelse",
    "blog.readMore": "Les mer",
    "blog.question": "Har du spørsmål? Vi hjelper deg gjerne!",
    "blog.whatsappCta": "Chat med oss på WhatsApp",
    "blog1.title": "Dokumenter du trenger for familiegjenforening fra Thailand",
    "blog1.desc": "Komplett oversikt over dokumenter som kreves for familiegjenforeningssøknader til UDI — med krav til oversettelse og legalisering.",
    "blog2.title": "Oversettelse av vigselsattest fra Thailand til norsk",
    "blog2.desc": "Alt du trenger å vite om oversettelse og godkjenning av thailandsk vigselsattest for norske myndigheter.",
    "blog3.title": "Hva koster oversettelse av thailandske dokumenter i 2026?",
    "blog3.desc": "Prisveiledning for sertifisert oversettelse av thai-dokumenter til norsk — fra enkeltdokumenter til komplett UDI-pakke.",

    // Chat widget
    "chat.greeting": "Hei! 👋 Trenger du hjelp med dokumentoversettelse? Vi svarer innen 24 timer.",
    "chat.close": "Lukk",
    "chat.button": "Chat med oss",
    "chat.call": "Ring oss",
    "chat.online": "Online nå",
    "chat.start": "Start chat",
  },
  th: {
    // Nav
    "nav.home": "หน้าแรก",
    "nav.services": "บริการ",
    "nav.process": "ขั้นตอน",
    "nav.faq": "คำถาม",
    "nav.getQuote": "รับใบเสนอราคา",
    "nav.blog": "บล็อก",
    "nav.menu": "เมนู",

    // Hero
    "hero.badge": "✓ การแปลเอกสารรับรองสำหรับ UDI",
    "hero.headline": "เราช่วยจัดการเอกสารทุกอย่างสำหรับการสมัคร UDI",
    "hero.sub": "การแปลเอกสารไทยเป็นนอร์เวย์อย่างเป็นทางการ เราดูแลทุกขั้นตอน — ตั้งแต่รายการเอกสารจนถึงการส่งใบสมัคร",
    "hero.cta": "รับการประเมินฟรี",
    "hero.whatsapp": "แชทบน WhatsApp →",
    "hero.whatsappSubtle": "หรือแชทกับเราทาง WhatsApp →",
    "hero.trust1": "ตอบกลับภายใน 24 ชั่วโมง",
    "hero.trust2": "แปลเอกสารแล้วกว่า 200+ ฉบับ",
    "hero.trust3": "อนุมัติโดย UDI 98%",
    "hero.availability": "🟢 เรารับลูกค้าใหม่อยู่",
    "hero.imgAlt": "หนังสือเดินทางนอร์เวย์และไทยพร้อมเอกสารราชการ",

    // Stats
    "stats.docsNum": "2000+",
    "stats.docs": "เอกสารที่แปลแล้ว",
    "stats.approvedNum": "98%",
    "stats.approved": "อนุมัติจาก UDI",
    "stats.experienceNum": "กว่า 40 ปี",
    "stats.experience": "ประสบการณ์",
    "stats.responseNum": "24 ชั่วโมง",
    "stats.response": "เวลาตอบสนอง",

    // Guarantee
    "guarantee.heading": "รับรอง 100% UDI อนุมัติ — หรือแก้ไขฟรี",
    "guarantee.text": "การแปลทั้งหมดได้รับการรับรองและอนุมัติจากหน่วยงานนอร์เวย์ หากเอกสารไม่ได้รับการอนุมัติจาก UDI เราจะแก้ไขให้ฟรี",

    // Why choose us
    "why.heading": "ทำไมต้องเลือก NordicThai Translate?",
    "why.1.title": "ความเชี่ยวชาญเฉพาะทาง",
    "why.1.desc": "เราทำงานเฉพาะด้านการแปลเอกสารไทย-นอร์เวย์เท่านั้น",
    "why.2.title": "จัดส่งรวดเร็ว",
    "why.2.desc": "มาตรฐาน 3-5 วันทำการ บริการด่วน 48 ชั่วโมง",
    "why.3.title": "บริการ WhatsApp ส่วนตัว",
    "why.3.desc": "ติดต่อโดยตรง — ไม่มีแชทบอท ไม่มีคอลเซ็นเตอร์",
    "why.4.title": "ช่วยเรื่องเอกสารครบวงจร",
    "why.4.desc": "เราตรวจสอบใบสมัครทั้งหมด ไม่ใช่แค่แปลอย่างเดียว",

    // How it works
    "how.heading": "ขั้นตอนการทำงาน",
    "how.step1.title": "ติดต่อเรา",
    "how.step1.desc": "ส่งเอกสารผ่าน WhatsApp หรือแบบฟอร์ม — ฟรีและไม่มีข้อผูกมัด",
    "how.step2.title": "ประเมินฟรี",
    "how.step2.desc": "เราตรวจสอบสิ่งที่คุณต้องการและส่งรายการเอกสารพร้อมใบเสนอราคา",
    "how.step3.title": "แปลเอกสาร",
    "how.step3.desc": "นักแปลที่ได้รับการรับรองแปลเอกสารจากไทยเป็นนอร์เวย์",
    "how.step4.title": "ตรวจสอบคุณภาพ",
    "how.step4.desc": "เอกสารทุกฉบับถูกตรวจสอบความถูกต้องและรับรอง",
    "how.step5.title": "จัดส่ง",
    "how.step5.desc": "รับเอกสารทางดิจิทัลหรือทางไปรษณีย์ — พร้อมสำหรับ UDI",

    // Services
    "services.heading": "บริการของเรา",
    "services.translation.title": "การแปลที่ได้รับการรับรอง",
    "services.translation.desc": "เอกสารราชการทั้งหมดจากไทยเป็นนอร์เวย์",
    "services.review.title": "ตรวจสอบเอกสาร UDI",
    "services.review.desc": "เราตรวจสอบว่าคุณมีเอกสารครบตาม UDI",
    "services.package.title": "แพ็กเกจเอกสารครบชุด",
    "services.package.desc": "ชุดเอกสารพร้อมยื่น",
    "services.express.title": "จัดส่งด่วน 48 ชม.",
    "services.express.desc": "บริการเร่งด่วนพร้อมให้บริการ",
    "services.price": "เริ่มต้น 450 โครน",
    "services.translation.price": "เริ่มต้น 450 โครนต่อเอกสาร",
    "services.review.price": "เริ่มต้น 850 โครน",
    "services.package.price": "เริ่มต้น 2,900 โครน",
    "services.express.price": "500 โครนเพิ่มเติม",
    "services.popular": "ยอดนิยม",
    "services.whatsapp": "แชทบน WhatsApp →",
    "services.quoteCta": "รับใบเสนอราคาฟรี →",

    // Document types
    "docs.heading": "เอกสารที่เราแปล",
    "docs.subtitle": "เอกสารทั้งหมดได้รับการรับรองสำหรับหน่วยงานนอร์เวย์ UDI และตำรวจ",
    "docs.missing": "ไม่เจอเอกสารของคุณในรายการ? แชทกับเรา →",
    "docs.0": "📄 ทะเบียนสมรส",
    "docs.1": "🏥 สูติบัตร",
    "docs.2": "🎓 ประกาศนียบัตร",
    "docs.3": "🏠 หนังสือรับรองที่อยู่",
    "docs.4": "💼 สัญญาจ้างงาน",
    "docs.5": "👮 ใบรับรองความประพฤติ",
    "docs.6": "🛂 ข้อมูลหนังสือเดินทาง",
    "docs.7": "📋 ข้อมูลบัญชี",
    "docs.8": "💑 ทะเบียนครอบครัว",
    "docs.9": "🏦 รายการเดินบัญชี",
    "docs.10": "📞 หนังสือรับรองการอยู่ร่วมกัน",
    "docs.11": "🩺 ใบรับรองแพทย์",

    // Testimonials
    "testimonials.heading": "ลูกค้าพูดถึงเรา",
    "testimonials.1.quote": "ฉันไม่รู้ว่าต้องใช้เอกสารอะไรบ้างสำหรับ UDI พวกเขาส่งรายการให้ฉันและจัดการทุกอย่างภายในหนึ่งสัปดาห์",
    "testimonials.2.quote": "เราแต่งงานที่ไทยและต้องการแปลทะเบียนสมรส รวดเร็ว เป็นมืออาชีพ และราคาเหมาะสม",
    "testimonials.3.quote": "แนะนำเลย! ใบสมัครได้รับการอนุมัติในครั้งแรกเพราะพวกเขาช่วยจัดการเอกสารทั้งหมด",
    "testimonials.verified": "ลูกค้ายืนยันแล้ว",

    "faq.heading": "คำถามที่พบบ่อย",
    "faq.1.q": "ต้องใช้เอกสารอะไรบ้างสำหรับการรวมครอบครัว UDI?",
    "faq.1.a": "เอกสารทั่วไปได้แก่: สูติบัตร ทะเบียนสมรส สำเนาหนังสือเดินทาง ใบรับรองความประพฤติ สเตทเมนต์ธนาคาร และเอกสารที่อยู่อาศัย",
    "faq.2.q": "คุณให้บริการรับรองเอกสารไหม?",
    "faq.2.a": "เราไม่ได้รับรองเอกสารเอง แต่เราจัดเตรียมและแปลเอกสารให้ตรงตามข้อกำหนดทั้งหมดสำหรับการรับรองและการยื่น UDI",
    "faq.3.q": "การแปลใช้เวลานานแค่ไหน?",
    "faq.3.a": "การแปลมาตรฐานใช้เวลา 3-5 วันทำการ บริการด่วน 48 ชั่วโมงพร้อมให้บริการ",
    "faq.4.q": "ค่าใช้จ่ายเท่าไหร่?",
    "faq.4.a": "ราคาขึ้นอยู่กับจำนวนและความซับซ้อนของเอกสาร แชทกับเราทาง WhatsApp เพื่อรับใบเสนอราคาฟรี",
    "faq.5.q": "คุณช่วยคนไทยที่อาศัยอยู่ในนอร์เวย์แล้วไหม?",
    "faq.5.a": "ใช่ เราช่วยทั้งคนไทยที่อาศัยในนอร์เวย์และคนที่กำลังย้ายจากประเทศไทย",
    "faq.6.q": "ต้องใช้เอกสารอะไรบ้างสำหรับการรวมครอบครัว?",
    "faq.6.a": "สำหรับการรวมครอบครัว คุณต้องใช้หนังสือเดินทาง สูติบัตร ทะเบียนสมรส (สำหรับคู่สมรส) ใบรับรองความประพฤติ และเอกสารรายได้จากผู้อ้างอิงในนอร์เวย์",
    "faq.7.q": "เอกสารของฉันต้องรับรองหรือ apostille ไหม?",
    "faq.7.a": "เอกสารสมรสสำหรับ UDI ไม่ต้อง apostille หรือรับรอง แต่ใบรับรองความประพฤติต้องรับรองจากกระทรวงการต่างประเทศไทย",
    "faq.8.q": "สำนักงานตั้งอยู่ที่ไหน?",
    "faq.8.a": "เราอยู่ใจกลางออสโล ห่างจากสถานทูตไทย 1 นาที ที่ Hausmanns gate 7",

    // About
    "about.heading": "เราเข้าใจทั้งสองฝั่งของใบสมัคร",
    "about.body": "NordicThai Translate ก่อตั้งโดยครอบครัวไทย-นอร์เวย์ที่ผ่านกระบวนการ UDI มาด้วยตัวเอง เรารู้ว่ามันเครียดแค่ไหนที่ต้องจัดการระบบราชการนอร์เวย์ — และเราพร้อมทำให้มันง่ายสำหรับคุณ",
    "about.bullet1": "ภาษาไทยเป็นภาษาแม่ — เราเข้าใจวัฒนธรรมและบริบท",
    "about.bullet2": "ได้รับการรับรองจากหน่วยงานนอร์เวย์ — UDI และตำรวจ",
    "about.bullet3": "ให้บริการทั่วนอร์เวย์ — จากออสโลถึงทรอมเซอ",
    "about.cta": "ดูขั้นตอนทั้งหมด →",

    // CTA
    "cta.text": "พร้อมเริ่มต้นหรือยัง? แชทกับเราทาง WhatsApp — ฟรีและไม่มีข้อผูกมัด",
    "cta.heading": "พร้อมที่จะยื่นใบสมัคร UDI หรือยัง?",
    "cta.sub": "เราช่วยคุณตั้งแต่รายการเอกสารจนถึงใบสมัครที่ได้รับอนุมัติ กรอกแบบฟอร์ม — เราตอบภายใน 24 ชั่วโมง",
    "cta.micro1": "ฟรี",
    "cta.micro2": "ตอบเร็ว",
    "cta.micro3": "ไม่มีข้อผูกมัด",
    "cta.button": "รับการประเมินฟรี →",
    "cta.stars": "⭐⭐⭐⭐⭐  ได้รับความไว้วางใจจาก 47+ ครอบครัวในนอร์เวย์",

    // Footer
    "footer.tagline": "บริการแปลเอกสารไทยเป็นนอร์เวย์อย่างเป็นทางการ สำหรับ UDI การสมรส และการรวมครอบครัว",
    "footer.links": "ลิงก์ด่วน",
    "footer.links.home": "หน้าแรก",
    "footer.links.services": "บริการ",
    "footer.links.documents": "เอกสาร",
    "footer.links.process": "ขั้นตอน",
    "footer.links.blog": "บล็อก",
    "footer.links.about": "เกี่ยวกับเรา",
    "footer.links.quote": "รับใบเสนอราคา",
    "footer.contact": "ติดต่อ",
    "footer.contactInquiry": "ส่งคำขอ",
    "footer.copyright": "© 2026 NordicThai Translate.",
    "footer.privacy": "นโยบายความเป็นส่วนตัว",

    // Visit section
    "visit.heading": "เยี่ยมชมเรา",
    "visit.iframeTitle": "สำนักงาน NordicThai Translate",
    "visit.title": "กรุณานัดหมายล่วงหน้าก่อนเข้าเยี่ยมชม",
    "visit.address": "ที่อยู่",
    "visit.addressValue": "Hausmanns gate 7, 0186 Oslo",
    "visit.hours": "เวลาทำการ",
    "visit.hoursValue": "จันทร์–ศุกร์ 09:00–17:00",
    "visit.cta": "ติดต่อเรา →",

    // Blog
    "blog.subtitle": "คำแนะนำและเคล็ดลับเกี่ยวกับการแปลเอกสารไทย-นอร์เวย์",
    "blog.readMore": "อ่านเพิ่มเติม",
    "blog.question": "มีคำถาม? เรายินดีช่วยเหลือ!",
    "blog.whatsappCta": "แชทกับเราทาง WhatsApp",
    "blog1.title": "เอกสารที่จำเป็นสำหรับการรวมครอบครัวจากประเทศไทย",
    "blog1.desc": "ภาพรวมครบถ้วนของเอกสารที่จำเป็นสำหรับการยื่นขอรวมครอบครัวกับ UDI — พร้อมข้อกำหนดการแปลและการรับรอง",
    "blog2.title": "การแปลทะเบียนสมรสจากประเทศไทยเป็นภาษานอร์เวย์",
    "blog2.desc": "ทุกสิ่งที่คุณต้องรู้เกี่ยวกับการแปลและรับรองทะเบียนสมรสไทยสำหรับหน่วยงานนอร์เวย์",
    "blog3.title": "ค่าบริการแปลเอกสารไทยในปี 2026 เท่าไหร่?",
    "blog3.desc": "แนวทางราคาสำหรับการแปลเอกสารไทยอย่างเป็นทางการ — ตั้งแต่เอกสารเดี่ยวจนถึงแพ็คเกจ UDI ครบชุด",

    // Chat widget
    "chat.greeting": "สวัสดี! 👋 ต้องการความช่วยเหลือเรื่องการแปลเอกสารไหม? เราตอบกลับภายใน 24 ชั่วโมง",
    "chat.close": "ปิด",
    "chat.button": "แชทกับเรา",
    "chat.call": "โทรหาเรา",
    "chat.online": "ออนไลน์อยู่",
    "chat.start": "เริ่มแชท",
  },
  en: {
    // Nav
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.process": "Process",
    "nav.faq": "FAQ",
    "nav.getQuote": "Get a Quote",
    "nav.blog": "Blog",
    "nav.menu": "Menu",

    // Hero
    "hero.badge": "✓ Certified translation for UDI",
    "hero.headline": "We help you with all documents for your UDI application.",
    "hero.sub": "Certified translation of Thai documents to Norwegian. We help you from A to Z — from document checklist to completed application.",
    "hero.cta": "Get free assessment",
    "hero.whatsapp": "Chat on WhatsApp →",
    "hero.whatsappSubtle": "Or chat with us on WhatsApp →",
    "hero.trust1": "Response within 24 hours",
    "hero.trust2": "200+ documents processed",
    "hero.trust3": "98% approved by UDI",
    "hero.availability": "🟢 We're accepting new clients now",
    "hero.imgAlt": "Norwegian and Thai passports with official documents",

    // Stats
    "stats.docsNum": "2000+",
    "stats.docs": "Documents translated",
    "stats.approvedNum": "98%",
    "stats.approved": "Approved by UDI",
    "stats.experienceNum": "40+ years",
    "stats.experience": "Experience",
    "stats.responseNum": "24 hours",
    "stats.response": "Response time",

    // Guarantee
    "guarantee.heading": "100% UDI-approved — or we fix it for free",
    "guarantee.text": "All translations are certified and approved by Norwegian authorities. If your document is not approved by UDI, we revise it at no cost.",

    // Why choose us
    "why.heading": "Why choose NordicThai Translate?",
    "why.1.title": "Specialized expertise",
    "why.1.desc": "We work exclusively with Thai-Norwegian document translation.",
    "why.2.title": "Fast delivery",
    "why.2.desc": "Standard 3–5 business days. Express delivery 48 hours.",
    "why.3.title": "Personal WhatsApp service",
    "why.3.desc": "Direct contact — no chatbots, no call centers.",
    "why.4.title": "Complete document help",
    "why.4.desc": "We review your entire application, not just translate.",

    // How it works
    "how.heading": "How it works",
    "how.step1.title": "Contact us",
    "how.step1.desc": "Send your documents via WhatsApp or form — free and non-binding.",
    "how.step2.title": "Free assessment",
    "how.step2.desc": "We check what you need and send you a complete list and quote.",
    "how.step3.title": "Translation",
    "how.step3.desc": "Certified translators translate your documents from Thai to Norwegian.",
    "how.step4.title": "Quality control",
    "how.step4.desc": "Every document is checked for accuracy and certified.",
    "how.step5.title": "Delivery",
    "how.step5.desc": "Receive your documents digitally or by post — ready for UDI.",

    // Services
    "services.heading": "Our services",
    "services.translation.title": "Certified translation",
    "services.translation.desc": "All official documents from Thai to Norwegian.",
    "services.review.title": "UDI document review",
    "services.review.desc": "We check that you have everything UDI requires.",
    "services.package.title": "Complete document package",
    "services.package.desc": "Full package ready for submission.",
    "services.express.title": "Express delivery 48h",
    "services.express.desc": "Rush orders available.",
    "services.price": "From 450 NOK",
    "services.translation.price": "From 450 NOK/doc",
    "services.review.price": "From 850 NOK",
    "services.package.price": "From 2,900 NOK",
    "services.express.price": "500 NOK surcharge",
    "services.popular": "Most popular",
    "services.whatsapp": "Chat on WhatsApp →",
    "services.quoteCta": "Get a free quote →",

    // Document types
    "docs.heading": "Documents we translate",
    "docs.subtitle": "All documents are certified for Norwegian authorities, UDI and the police.",
    "docs.missing": "Can't find your document on the list? Chat with us →",
    "docs.0": "📄 Marriage certificate",
    "docs.1": "🏥 Birth certificate",
    "docs.2": "🎓 Diploma",
    "docs.3": "🏠 Proof of residence",
    "docs.4": "💼 Employment contract",
    "docs.5": "👮 Police clearance",
    "docs.6": "🛂 Passport details",
    "docs.7": "📋 Account details",
    "docs.8": "💑 Family registration",
    "docs.9": "🏦 Bank statement",
    "docs.10": "📞 Cohabitation declaration",
    "docs.11": "🩺 Medical certificate",

    // Testimonials
    "testimonials.heading": "What our clients say",
    "testimonials.1.quote": "I didn't know what I needed for UDI. They sent me a complete list and handled everything in one week.",
    "testimonials.2.quote": "We got married in Thailand and needed our marriage certificate translated. Fast, professional, and fairly priced.",
    "testimonials.3.quote": "Highly recommended! Our application was approved the first time thanks to their help with all the paperwork.",
    "testimonials.verified": "Verified client",

    "faq.heading": "Frequently asked questions",
    "faq.1.q": "What documents do I need for UDI family immigration?",
    "faq.1.a": "Common documents include: birth certificate, marriage certificate, passport copies, police clearance, bank statements, and housing documentation.",
    "faq.2.q": "Do you provide notarization?",
    "faq.2.a": "We don't notarize documents ourselves, but we prepare and translate your documents to meet all requirements for notarization and UDI submission.",
    "faq.3.q": "How long does translation take?",
    "faq.3.a": "Standard translation takes 3–5 business days. Express 48-hour delivery is available for urgent cases.",
    "faq.4.q": "How much does it cost?",
    "faq.4.a": "The price depends on the number and complexity of documents. Chat with us on WhatsApp for a free estimate.",
    "faq.5.q": "Do you help Thai people already living in Norway?",
    "faq.5.a": "Yes. We help both Thai citizens living in Norway and those in the process of moving from Thailand.",
    "faq.6.q": "What documents do I need for family reunification?",
    "faq.6.a": "For family reunification you typically need a valid passport, birth certificate, marriage certificate (for spouses), police clearance, and income documentation from the reference person in Norway.",
    "faq.7.q": "Do my documents need legalization or apostille?",
    "faq.7.a": "Marriage documents for UDI do NOT need apostille or legalization. However, criminal records MUST be legalized by the Thai Ministry of Foreign Affairs before submission.",
    "faq.8.q": "Where are you located?",
    "faq.8.a": "We are located in Oslo city center, 1 minute from the Thai Embassy at Hausmanns gate 7.",

    // About
    "about.heading": "We understand both sides of the application",
    "about.body": "NordicThai Translate was started by a Thai-Norwegian family who went through the UDI process themselves. We know how stressful it is to navigate Norwegian bureaucracy — and we're here to make it easy for you.",
    "about.bullet1": "Thai native language — we understand the culture and context",
    "about.bullet2": "Certified for Norwegian authorities — UDI and police",
    "about.bullet3": "Serving all of Norway — from Oslo to Tromsø",
    "about.cta": "See the full process →",

    // CTA
    "cta.text": "Ready to get started? Chat with us on WhatsApp — free and non-binding.",
    "cta.heading": "Ready to secure your UDI application?",
    "cta.sub": "We help you with everything from document checklist to approved application. Fill out the form — we respond within 24 hours.",
    "cta.micro1": "Free",
    "cta.micro2": "Fast response",
    "cta.micro3": "No obligation",
    "cta.button": "Get free assessment →",
    "cta.stars": "⭐⭐⭐⭐⭐  Trusted by 47+ families in Norway",

    // Footer
    "footer.tagline": "Certified translation of Thai documents to Norwegian for UDI, marriage and family reunification.",
    "footer.links": "Quick links",
    "footer.links.home": "Home",
    "footer.links.services": "Services",
    "footer.links.documents": "Documents",
    "footer.links.process": "Process",
    "footer.links.blog": "Blog",
    "footer.links.about": "About us",
    "footer.links.quote": "Get a quote",
    "footer.contact": "Contact",
    "footer.contactInquiry": "Send inquiry",
    "footer.copyright": "© 2026 NordicThai Translate.",
    "footer.privacy": "Privacy",

    // Visit section
    "visit.heading": "Visit us",
    "visit.iframeTitle": "NordicThai Translate office",
    "visit.title": "Please book an appointment before visiting",
    "visit.address": "Address",
    "visit.addressValue": "Hausmanns gate 7, 0186 Oslo",
    "visit.hours": "Opening hours",
    "visit.hoursValue": "Mon–Fri 09:00–17:00",
    "visit.cta": "Contact us →",

    // Blog
    "blog.subtitle": "Guides and tips on Thai-Norwegian document translation",
    "blog.readMore": "Read more",
    "blog.question": "Have questions? We're happy to help!",
    "blog.whatsappCta": "Chat with us on WhatsApp",
    "blog1.title": "Documents you need for family reunification from Thailand",
    "blog1.desc": "Complete overview of documents required for family reunification applications to UDI — with translation and legalization requirements.",
    "blog2.title": "Translation of marriage certificate from Thailand to Norwegian",
    "blog2.desc": "Everything you need to know about translation and approval of Thai marriage certificates for Norwegian authorities.",
    "blog3.title": "How much does Thai document translation cost in 2026?",
    "blog3.desc": "Price guide for certified translation of Thai documents to Norwegian — from single documents to complete UDI packages.",

    // Chat widget
    "chat.greeting": "Hi! 👋 Need help with document translation? We respond within 24 hours.",
    "chat.close": "Close",
    "chat.button": "Chat with us",
    "chat.call": "Call us",
    "chat.online": "Online now",
    "chat.start": "Start chat",
  },
};
